import { getLocaleCurrencyCode, getLocaleNumberSymbol, NumberSymbol } from '@angular/common';

//FYI: decimal thousand separator or dot thousand seprator cannot ne replace for all value

export function getCurrencyValueFormat(currencyValue, locale) {
  if (currencyValue.match(/\s+/)) {
    currencyValue = currencyValue.replace(/\s/g, '');
  }
  if (getLocaleNumberSymbol(locale, NumberSymbol.CurrencyGroup) === ',') {
    currencyValue = currencyValue.replace(/,/g, '');
    return getCurrencyDecimalFormat(currencyValue, locale);
  }
  if (getLocaleNumberSymbol(locale, NumberSymbol.CurrencyGroup) === '.') {
    currencyValue = currencyValue.replace(/./g, '');
    return getCurrencyDecimalFormat(currencyValue, locale);
  } else {
    return getCurrencyDecimalFormat(currencyValue, locale);
  }
}

export function checkWhiteSpace(value: string) {
  return value.replace(/\s/g, '');
}

export function getCurrencyDecimalFormat(currencyValue, locale) {
  if (getLocaleNumberSymbol(locale, NumberSymbol.CurrencyDecimal) === ',') {
    //Check if decimal has comma as separator and replace with dot
    return currencyValue.replace(/,/g, '.');
  } else {
    return currencyValue;
  }
}
export function getUserAssignedCurrencyFormat(value, locale, userAssignedCurrencyCode = getLocaleCurrencyCode(locale)) {
  const formatter = new Intl.NumberFormat(locale, {
    style: 'currency',
    currency: userAssignedCurrencyCode,
    minimumFractionDigits: 2,
  });
  const parts = formatter.formatToParts(value);
  const result = formatParts(parts);
  return result.symbol + ' ' + result.value;
}
function formatParts(parts) {
  const currency = parts.find((part) => part.type === 'currency');
  const value = parts
    .filter((part) => part.type !== 'currency')
    .map((part) => part.value)
    .join('');

  return { symbol: currency.value, value };
}

// export function getUserAssignedCurrencyFormat(value, locale, userAssignedCurrencyCode = getLocaleCurrencyCode(locale)) {


